// @ts-ignore

import { GlobalFooter } from "@/patterns/global-footer/src";
import GlobalNav from "@/patterns/global-nav/src";
import { LocationProvider } from "@/utils/location-provider";

import { MainSection } from "./sections/main";

export const FourOhFourPageTemplate = () => {
    return (
        <div data-testid="404-page">
            <LocationProvider
                location={
                    typeof window !== "undefined"
                        ? window.location
                        : ({ pathname: "/", href: "/" } as Location)
                }
            >
                <div>
                    <GlobalNav
                        isShowTryNowLink={true}
                        tryNowLinkCtaButtonColor="light_grey"
                        productKey="404"
                    />
                </div>
                <div>
                    <div>
                        <MainSection />
                    </div>
                </div>
                <GlobalFooter />
            </LocationProvider>
        </div>
    );
};
